import React from 'react'

import { TabelaColuna, TabelaDados } from 'src/componentes'
import { formatadores } from 'src/paginas/aluno/painel-financeiro/pagina-financeiro/formatadores'

export const colunaValorParcelaTaxaMatricula = (): TabelaColuna => ({
  Chave: 'ValorParcelaTaxaMatricula',
  ComOrdenacao: true,
  Renderizar: (linha: TabelaDados) => (
    <span>{formatadores.moeda(linha.ValorParcelaTaxaMatricula)}</span>
  ),
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Valor Parcela Taxa Matrícula</div>
  )
})
